module.exports = __webpack_public_path__ + "img/Walls_text06a_predAfalse.03f51db7.png";